import React, { useCallback, useEffect, useRef, useState } from "react";
import GlobalCard from "../../../components/GlobalCardComponent";
import { Box, Button, Card, Grid, Typography } from "@mui/material";
import SessionBoxCards from "./SessionBoxCards";
import { fDate } from "../../../../utils2/formatTime";
import parse from "html-react-parser";
import LessonPlanner from "./LessonPlan";
import ProgressCard from "../attendance/ProgressCard";
import AttendanceCalendarCard from "../attendance/AttendanceCalendarCard";
import ViewLeaveRequest from "../attendance/ViewLeaveRequest";
export default function SessionDetailsCard({ classDetails, loading }) {
  const currentDate = new Date().toISOString().split("T")[0];
  console.log("classDetails10", currentDate, classDetails?.enrollment_date);

  const [expandedDays, setExpandedDays] = useState({});
  const [showToggleButton, setShowToggleButton] = useState({});

  const textRefs = useRef({});
  const LINE_HEIGHT_PX = 16.8;

  // hide and show button

  useEffect(() => {
    if (!classDetails?.lession_plan?.day) return;

    const newShowToggle = {};

    classDetails.lession_plan.day.forEach((day) => {
      const ref = textRefs.current[day?.date];
      if (ref) {
        const fullHeight = ref.scrollHeight;
        const maxHeight = LINE_HEIGHT_PX * 2;
        newShowToggle[day.date] = fullHeight > maxHeight;
      }
    });

    setShowToggleButton(newShowToggle);
  }, [classDetails]);

  const toggleExpand = (dateKey) => {
    setExpandedDays((prev) => ({
      ...prev,
      [dateKey]: !prev[dateKey],
    }));
  };

  return (
    <>
      <GlobalCard height="100%">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography
              color="#000000"
              fontFamily="Inter"
              fontSize="20px"
              lineHeight="100%"
              letterSpacing="0px"
              fontStyle="normal"
              style={{ fontWeight: 400 }}
            >
              Session & Details
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Box
              sx={{
                height: "1px", // define desired height
                width: "100%", // or a fixed width like '400px'
                backgroundColor: "#666666",
              }}
            ></Box>
          </Grid>

          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <ProgressCard
                  attendanceDetails={classDetails}
                  loading={loading}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <AttendanceCalendarCard
                  student_class_details_id={classDetails?.id}
                />
              </Grid>

              <Grid item xs={12} height="100%">
                <ViewLeaveRequest
                  attendanceDetails={classDetails}
                  loading={loading}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </GlobalCard>
    </>
  );
}
